// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"SidebarToggle_Toggle__2AD2R","Closed":"SidebarToggle_Closed__1-f0n","Opened":"SidebarToggle_Opened__3P3BC","Hidden":"SidebarToggle_Hidden__3L4wK"};